import { flash } from "../../assets/images/icons";

export const getDisplayDate = () => {
  const date = new Date();
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const displayDate = `${
    days[date.getDay()]
  }, ${date.getDate()} ${
    monthNames[date.getMonth()]
  } ${date.getFullYear()}`;

  return displayDate;
};

export const appendHeader = () => {
  if (
    document?.getElementsByClassName("chat-container")?.[0]
  ) {
    document
      .getElementsByClassName("chat-container")?.[0]
      ?.classList?.add("chat-bottom");

    const displayDate = getDisplayDate();

    const parent = document?.getElementsByClassName(
      "chat-container"
    )[0];
    const newElement = document?.createElement("div");
    newElement.className = "support-header";

    const headerContainerChild = document?.createElement(
      "div"
    );

    const headerChild = document?.createElement("div");
    headerChild.innerHTML = "Contact Support";
    headerChild.className = "header-title";

    const dateChild = document?.createElement("div");
    dateChild.innerHTML = displayDate;
    dateChild.className = "display-date";

    headerContainerChild.appendChild(headerChild);
    headerContainerChild.appendChild(dateChild);

    const svgChild = document?.createElement("div");
    svgChild.innerHTML = flash;
    svgChild.className = "flash-icon";

    newElement.appendChild(svgChild);
    newElement.appendChild(headerContainerChild);

    parent.insertBefore(newElement, parent.firstChild);
  }
};
